import {
  Inject,
  OnInit,
  Component,
  ViewChild,
  TemplateRef,
  AfterViewInit,
  ChangeDetectorRef,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IConfirmationModalConfig } from './confirmation-modal.service';

@Component({
  selector: 'sociuu-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styles: [
    /* language=SCSS */
    `
      .fuse-confirmation-dialog-panel {
        @screen md {
          @apply w-128;
        }

        .mat-dialog-container {
          padding: 0 !important;
        }
      }
    `,
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent implements OnInit, AfterViewInit {
  @ViewChild('inputConfirmTemplate') public inputConfirmTemplate: TemplateRef<HTMLElement>;
  @ViewChild('checkboxConfirmTemplate') public checkboxConfirmTemplate: TemplateRef<HTMLElement>;
  @ViewChild('slideToggleConfirmTemplate') public slideToggleConfirmTemplate: TemplateRef<HTMLElement>;

  // Secondary action templates
  @ViewChild('secondaryActionCheckboxConfirmTemplate') public secondaryActionCheckboxConfirmTemplate: TemplateRef<HTMLElement>;

  public confirmationInput: string;
  public confirmationCheck: boolean = false;
  public templates: TemplateRef<HTMLElement>[] = [];

  public get isConfirmDisabled(): boolean {
    if (!this.data.template) return false;

    if (!this.data.template?.customTemplateForm) {
      if (this.data.template.value) return this.confirmationInput !== this.data.template.value;
    }
    else return this.data.template.customTemplateForm.invalid;
  }

  public get matDialogData(): any {
    if (this.data.template?.templateType === 'slideToggle') {
      return {
        status: 'confirmed',
        data: this.confirmationCheck,
      };
    }
    else if (this.data.template?.secondaryAction) {
      return {
        status: 'confirmed',
        data: {
          primaryActionValue: this.data.primaryActionValue,
          secondaryActionValue: this.data.secondaryActionValue,
        },
      };
    }
    else return 'confirmed';
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IConfirmationModalConfig,
    public matDialogRef: MatDialogRef<ConfirmationModalComponent>,
    private cdr: ChangeDetectorRef,
  ) { }

  public ngOnInit(): void { }

  public preventPaste(event: ClipboardEvent): void {
    event.preventDefault();
  }

  public ngAfterViewInit(): void {
    this.setTemplates();
  }

  public onConfirmClick(): void {
    // Execute the callback function if provided
    if (this.data?.onConfirm) {
      this.data.onConfirm();
    }

    // Close the dialog with the appropriate data
    this.matDialogRef.close(this.matDialogData);
  }

  private setTemplates(): void {
    if (this.data?.template) {
      const template = this.data.template;
      switch (template.templateType) {
        case 'confirmInput': {
          this.templates.push(this.inputConfirmTemplate);
          break;
        }
        case 'checkbox': {
          this.templates.push(this.checkboxConfirmTemplate);
          break;
        }
        case 'slideToggle': {
          this.templates.push(this.slideToggleConfirmTemplate);
          break;
        }
        case 'custom': {
          this.templates.push(template.templateRef);
          break;
        }
        default: {
          this.templates.push(null);
          break;
        }
      }
    }
    if (this.data?.template?.secondaryAction) {
      const template = this.data.template.secondaryAction;
      switch (template.templateType) {
        case 'checkbox': {
          this.templates.push(this.secondaryActionCheckboxConfirmTemplate);
          break;
        }
        default: {
          this.templates.push(null);
          break;
        }
      }
    }
    if (!this.data?.template) {
      this.templates = [];
    }
    this.cdr.detectChanges();
  }
}

